import Vue from 'vue'
import Router from 'vue-router'
import c from '@/components'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/purifiers/:id',
      props: true,
      component: c.PurifierDetailView
    },
    {
      path: '/',
      component: c.SelectorView,
      props: true
    },
    {
      path: '/sensitive-to-noise',
      component: c.NoiseView
    },
    {
      path: '/no-purifier-selection',
      component: c.NoChoicesView
    },
    {
      path: '/low-cost-purifiers',
      component: c.LowCostView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js